// JSX Structure Syntactic Sugar. Never reach the render code.
/* istanbul ignore next */
const DescriptionsItem = _ref => {
  let {
    children
  } = _ref;
  return children;
};
export default DescriptionsItem;